// Reserved keywords not allowed to use in the parser
export var keywords = {
  end: true
};